import { defineAsyncComponent } from 'vue'
export default {
  blogpost: defineAsyncComponent(() => import("/vercel/path0/layouts/blogpost.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/vercel/path0/layouts/home.vue").then(m => m.default || m))
}